import { createContext, useContext } from 'react';
import {
    EnumFrontendLayoutSetting,
    EnumFrontendLayoutSettingGroups,
    EnumFrontendLayoutSettingModuleName,
} from '@Model';

import { type Undefined, type Result, type Nullable } from '@synqo/frontend-component-library';
import type { ApiSetting } from '@Model';

export type TSetting = ApiSetting<
    EnumFrontendLayoutSetting,
    EnumFrontendLayoutSettingGroups,
    EnumFrontendLayoutSettingModuleName
>;

type GetParsedSettingReturnType<T> = {
    data: Nullable<T>;
    setting: Undefined<TSetting>;
};

export interface IFrontendLayoutSettingsContext {
    getSetting: (setting: EnumFrontendLayoutSetting) => Undefined<TSetting>;
    getParsedSetting: <T>(setting: EnumFrontendLayoutSetting) => GetParsedSettingReturnType<T>;
    updateSetting: (setting: TSetting) => Promise<Result<TSetting>>;
    updateSettings: () => Promise<Result<TSetting[]>>;
}

export const FrontendLayoutSettingsContext = createContext<IFrontendLayoutSettingsContext>({
    getSetting: () => undefined,
    getParsedSetting: () => ({ data: null, setting: undefined }),
    updateSetting: async () => ({ data: undefined, messages: [] }),
    updateSettings: async () => ({ data: undefined, messages: [] }),
});

export function useFrontendLayoutSettings(): IFrontendLayoutSettingsContext {
    const frontendLayoutSettingsContext = useContext(FrontendLayoutSettingsContext);
    return frontendLayoutSettingsContext;
}
